// extracted by mini-css-extract-plugin
module.exports = {"modal":"ErrorHandler_modal__2Uuu0","image":"ErrorHandler_image__3Gifu","text":"ErrorHandler_text__2hjhk","buttonGroup":"ErrorHandler_buttonGroup__2lvGV"};